export default "__VITE_ASSET__8px1To1K__"